import { loadImage } from './load';

const cachedImages = new Map<string, HTMLImageElement>();

export function getCachedImage(imageUrl: string, key?: string): Promise<HTMLImageElement> {
    key = key || imageUrl;
    return new Promise((resolve, reject) => {
        if (cachedImages.has(key)) {
            resolve(cachedImages.get(key));
        } else {
            loadImage(imageUrl).then((image) => {
                cachedImages.set(key, image);
                resolve(image);
            }).catch((error) => {
                reject(error);
            });
        }
    });
}

export function clearCachedImage(imageUrl: string, key?: string) {
    key = key || imageUrl;
    if (cachedImages.has(key)) {
        cachedImages.delete(key);
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/image/cache.ts
 **/